import {
  FETCH_APPDATA_REQUESTING,
  GET_USERDETAILS,
  GET_CHALLENGEQUESTIONS,
  UDPATE_ACCOUNT_ACTIVATE_DATA,
  CHECK_ACTIVATION,
  USER_ACTIVATION,
  GET_USERINFO,
  UPDATE_USERINFO,
  SAVE_SECURITYQUESTIONS,
  UPDATE_RESETPASSWORD_USERINFO,
  GET_RESETPASSWORD_USERINFO,
  SAVE_RESETPASSWORD,
  GET_CHANGEPASSWORD_USERINFO,
  UPDATE_CHANGEPASSWORD_USERINFO,
  SAVE_CHANGEPASSWORD,
  GET_EXPIREDPASSWORD_USERINFO,
  UPDATE_EXPIREDPASSWORD_USERINFO,
  SAVE_EXPIREDPASSWORD,
  VERIFY_EMAIL
} from './actionTypes';

export function fetchAppData(params) {
  return {
    type: FETCH_APPDATA_REQUESTING,
    params: params
  }
}

/*Query userdetails*/
export function getUserDetails(params) {
  return {
    type: GET_USERDETAILS,
    params: params
  }
}

export function getChallengeQuestions(params) {
  return {
    type: GET_CHALLENGEQUESTIONS,
    params: params
  }
}

export function updateAccountActivateData(params) {
  return {
    type: UDPATE_ACCOUNT_ACTIVATE_DATA,
    params: params
  }
}

export function checkAccountActivationStatus(params) {
  return {
    type: CHECK_ACTIVATION,
    params: params
  }
}

export function activateUser(params) {
  return {
    type: USER_ACTIVATION,
    params: params
  }
}

export function getUserInfo(params) {
  return {
    type: GET_USERINFO,
    params: params
  }
}

export function updateUserInfo(params) {
  return {
    type: UPDATE_USERINFO,
    params: params
  }
}

export function saveSecurityQuestions(params){
  return {
    type: SAVE_SECURITYQUESTIONS,
    params:params
  }
}

export function getResetpasswordUserInfo(params) {
  return {
    type: GET_RESETPASSWORD_USERINFO,
    params: params
  }
}

export function updateResetPasswordUserInfo(params) {
  return {
    type: UPDATE_RESETPASSWORD_USERINFO,
    params: params
  }
}

export function saveResetPassword(params){
  return {
    type: SAVE_RESETPASSWORD,
    params:params
  }
}


export function getChangePasswordUserInfo(params) {
  return {
    type: GET_CHANGEPASSWORD_USERINFO,
    params: params
  }
}

export function updateChangePasswordUserInfo(params) {
  return {
    type: UPDATE_CHANGEPASSWORD_USERINFO,
    params: params
  }
}

export function saveChangePassword(params){
  return {
    type: SAVE_CHANGEPASSWORD,
    params:params
  }
}


export function getExpiredPasswordUserInfo(params) {
  return {
    type: GET_EXPIREDPASSWORD_USERINFO,
    params: params
  }
}

export function updateExpiredPasswordUserInfo(params) {
  return {
    type: UPDATE_EXPIREDPASSWORD_USERINFO,
    params: params
  }
}

export function saveExpiredPassword(params){
  return {
    type: SAVE_EXPIREDPASSWORD,
    params:params
  }
}

export function verifyEmail(params) {
  return {
    type: VERIFY_EMAIL,
    params: params
  }
}